{
  "login": {
    "welcome": "Bienvenido",
    "switch_to_en": "Cambiar a inglés",
    "title": "Environet - Iniciar sesión",
    "recover_pwd_title": "Recuperar la contraseña",
    "email": "introduzca su dirección de correo electrónico",
    "password": "contraseña",
    "remember_me": "Seguir conectado",
    "forgot_password": "¿Olvidó la contraseña?",
    "submit": "Iniciar sesión",
    "login_please": "¡Por favor inicie sesión!",
    "not_authorized": "No está autorizado para ver esta página. ¡Inicie sesión primero!",
    "already_logged_in": "Ya inició sesión. ¡Cierre la sesión primero!",
    "logged_in": "¡Ya inició sesión!",
    "logged_out": "¡Cerró la sesión!",
    "contact_support": "Ponerse en contacto con el soporte",
    "copyright": "Un producto de Netronix Inc.",
    "password_reset_text": "La información para restablecer la contraseña se enviará a la dirección de correo electrónico que usted nos proporcione.",
    "password_reset": "Restablecer contraseña",
    "powered_by": "Desarrollado por Netronix, Inc.",
    "signup_successful": "El registro fue exitoso, inicie sesión."
  }
}
